export const enum TagsClassNamesEnum {
	tagGhost = 'tagGhost', // пустой тег без названия
	tagGhostWithTitle = 'tagGhostWithTitle', // пустой тег когда вводим название
	tagFull = 'tagFull', //  добавленный тег
}
